import { create } from 'zustand'

type PendingNav = (() => void) | null

type UnsavedChangesState = {
  isDirty: boolean
  isDialogOpen: boolean
  message: string
  pendingNavigation: PendingNav
  setDirty: (dirty: boolean) => void
  setMessage: (message: string) => void
  requestLeave: (navigateFn: () => void) => void
  confirmLeave: () => void
  cancelLeave: () => void
}

const DEFAULT_MESSAGE = 'Changes might not be saved'

export const useUnsavedChangesStore = create<UnsavedChangesState>((set, get) => ({
  isDirty: false,
  isDialogOpen: false,
  message: DEFAULT_MESSAGE,
  pendingNavigation: null,

  setDirty: (dirty) => {
    set({ isDirty: dirty })
    if (!dirty) {
      set({ isDialogOpen: false, pendingNavigation: null })
    }
  },

  setMessage: (message) => set({ message }),

  requestLeave: (navigateFn) => {
    const { isDirty } = get()
    if (!isDirty) {
      navigateFn()
      return
    }
    set({ pendingNavigation: navigateFn, isDialogOpen: true })
  },

  confirmLeave: () => {
    const { pendingNavigation } = get()
    set({ isDialogOpen: false, pendingNavigation: null, isDirty: false })
    pendingNavigation?.()
  },

  cancelLeave: () => {
    set({ isDialogOpen: false, pendingNavigation: null })
  },
}))
